import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import LinkIcon from '../../../icons/LinkIcon';

const OptionsModal = (props) => {
  const {
    onClose,
  } = props;

  return (
    <Modal
      show
      onHide={onClose}
      backdrop
      centered
      className="options-submit-modal"
    >
      <div className="options-submit-modal-div">
        <Modal.Header closeButton id="options-modal-title">
          <h1 id="page-header" className="h1_secondary">
            Options Trading
          </h1>
        </Modal.Header>
        <Modal.Body className="options-submit-modal-body">
          <p className="panel-question">
            Enabling options trading allows you to buy and sell options contracts, which can help you generate income,
            protect against losses, and speculate on the market. Options trading requires approval based on your
            experience and financial profile and may involve margin requirements.
            <br /><br />
            Options trading is not suitable for all investors.&nbsp;
            <a
              href="https://www.theocc.com/Company-Information/Documents-and-Archives/Options-Disclosure-Document"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn more {LinkIcon}
            </a>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-center">
            <button
              type="button"
              className="btn btn-raised btn-default do_capitalize"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

OptionsModal.propTypes = {
  onClose: PropTypes.func,
};

export default OptionsModal;
